import React, { CSSProperties } from "react";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import { RangePickerProps as AntRangePickerProps } from "antd/lib/date-picker";
import styled from "styled-components";
import { ReactComponent as Bar } from "../../../assets/icons/Bar.svg";
import { ReactComponent as Date } from "../../../assets/icons/DatePicker.svg";
import { ReactComponent as Cancel } from "../../../assets/icons/Cancel.svg";
import { theme } from "../../../theme";

const { RangePicker } = DatePicker;

export type DateRangePickerProps = AntRangePickerProps & {
  style?: CSSProperties;
};

const DateRangePicker: React.FC<DateRangePickerProps> = (props) => {
  const { ...rest } = props;
  return (
    <DateRange
      locale={locale}
      size="middle"
      suffixIcon={<Date />}
      separator="-"
      clearIcon={<Cancel />}
      disabledDate={(date) => {
        if (date.year() > 9999 || date.year() < 0) return true;
        if (rest.disabledDate) return rest.disabledDate(date);
        return false;
      }}
      {...rest}
    />
  );
};
export default DateRangePicker;
const DateRange = styled(RangePicker)`
  background-color: #fff;

  transition: all 0.3s;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  height: 32px;
  input {
    line-height: 14px;
  }
  input::placeholder {
    color: ${theme.colors.gray3};
  }
  &:hover {
    border-color: none;
  }
`;
